import { PureComponent } from "react";

import { BTStatusBadge } from "@btnet/core-components";

import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    GridColumnType,
    type IClientGridColumn,
} from "commonComponents/utilities/Grid/GridContainer.types";

export class BillDocumentTypeCell extends PureComponent<IGridCellRenderProps<string>> {
    render() {
        const { cellValue, field } = this.props;
        if (!cellValue) {
            return null;
        }

        return (
            <span data-testid={field.full}>
                <BTStatusBadge
                    testid="documentTypeTag"
                    text={cellValue}
                    displayType={cellValue === "Receipt" ? "info" : "default"}
                    textOnly
                />
            </span>
        );
    }
}

export const columnBillDocumentType: IClientGridColumn<string> = {
    columnType: GridColumnType.billDocumentType,
    Cell: BillDocumentTypeCell,
};
